import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { Icon } from '@/shared/ui/icon'
import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { AppButton } from '@/shared/ui/button'
import { $userKeys } from '@/entities/cases'
import { goToShop } from '@/app/routing/events'

export const YourKeys = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.boxPage
  const btnTexts = lang[userLang].pages.btnTexts
  const userKeys = useUnit($userKeys)

  return (
    <>
      <div className={classes.root}>
        <div className={classes.textAndBalanceWrapper}>
          <span className={classes.yourKeysText}>{texts.yourKeys}:</span>
          <div className={classes.balanceWrapper}>
            <Icon view="gamedKey" style={{ alignSelf: 'center' }} />
            <span className={classes.balanceAmount}>{userKeys}</span>
          </div>
        </div>
        <AppButton className={classes.button} onClick={() => goToShop({ tab: 2 })}>
          {btnTexts.buy}
        </AppButton>
      </div>
    </>
  )
}
